import React, { useState, useRef } from 'react';

import arrowDropdown from 'img/arrow-dropdown.svg';

import './styles.scss';

export const DropdownCustomerForSupplier = () => {

  const wrapperRef = useRef(null);

  return (
      <div
        ref={wrapperRef}
        className="dropdown-customer dropdown-customer-mobile"
      >
        <span className="yellow-arrow">
          <img src={arrowDropdown} alt="Seta do dropdown de cliente" />
        </span>

        <div className="customer-current">
          <div>
            <span>Empresa selecionada</span>
            <div className="customer-current--selected">
              Todas as Empresas
            </div>
          </div>
          <span className="btn-background">
            <button
              className="customer-current--btn"
            />
          </span>
        </div>
      </div>
  );
};
